module.exports = __webpack_public_path__ + "static/media/FWS.a55a3861.pdf";